import React from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsToolbar = ({ selectedCount, onBulkAction }) => {
  const bulkActionOptions = [
    { value: '', label: 'اختر إجراء جماعي' },
    { value: 'update_status', label: 'تحديث الحالة' },
    { value: 'notify_owners', label: 'إشعار الملاك' },
    { value: 'generate_contracts', label: 'إنشاء عقود' },
    { value: 'export_selected', label: 'تصدير المحدد' },
    { value: 'delete', label: 'حذف' }
  ];

  if (selectedCount === 0) {
    return null;
  }

  const handleActionChange = (value) => {
    if (value && value !== '') {
      onBulkAction(value);
    }
  };

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
          <span className="text-sm font-bold text-primary-foreground font-data" dir="ltr">{selectedCount}</span>
        </div>
        <div>
          <p className="text-sm font-medium text-foreground">
            تم تحديد <span className="font-data" dir="ltr">{selectedCount}</span> عقار
          </p>
          <p className="text-xs text-muted-foreground">
            يمكنك تطبيق إجراءات جماعية على العقارات المحددة
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 w-full md:w-auto">
        <Select
          options={bulkActionOptions}
          value=""
          onChange={handleActionChange}
          placeholder="اختر إجراء"
          className="flex-1 md:w-64"
        />
        <Button
          variant="outline"
          iconName="X"
          iconSize={16}
          onClick={() => onBulkAction('clear')}
        >
          إلغاء التحديد
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;